export default function PageHeader({ eyebrow, title, lede, image, imageAlt, imageClassName, imageWrapperClassName, testid }) {
  return (
    <section className="pt-24 md:pt-32 border-b border-rule" data-testid={testid || "page-header"}>
      <div className="max-w-[1240px] mx-auto px-6 md:px-10 lg:px-14 pb-16 md:pb-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          <div className="md:col-span-3">
            {eyebrow && <div className="eyebrow page-enter">{eyebrow}</div>}
          </div>
          <div className="md:col-span-9">
            <h1 className="display-1 text-5xl sm:text-6xl md:text-7xl text-ink page-enter delay-1" data-testid="page-title">
              {title}
            </h1>
            {lede && (
              <p className="lede mt-8 text-xl md:text-2xl max-w-3xl page-enter delay-2">
                {lede}
              </p>
            )}
          </div>
        </div>
      </div>

      {image && (
        <div className="max-w-[1240px] mx-auto px-6 md:px-10 lg:px-14 pb-16 md:pb-20" data-testid="page-header-image">
          <div className={`aspect-[16/8] md:aspect-[16/7] overflow-hidden bg-earth-dark/20 page-enter delay-3${imageWrapperClassName ? ` ${imageWrapperClassName}` : ""}`}>
            <img
              src={image}
              alt={imageAlt || ""}
              className={`w-full h-full object-cover photo-treat${imageClassName ? ` ${imageClassName}` : ""}`}
              loading="eager"
            />
          </div>
        </div>
      )}
    </section>
  );
}
